import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";


const Main = lazy (
  () => import("../components/approval/main")
);

const NomineeApproval = () => {
  return (
    // <Layout>
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    // </Layout>
  );
};

export default NomineeApproval;
